import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ContentPlaceholderAnimationComponent } from './content-placeholder-animation/content-placeholder-animation.component';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { LayoutComponent } from './layout/layout.component';
import { UpdateStatusDialogComponent, FetchEntityDialogComponent, DeleteEntityDialogComponent, ErrorEntityDialogComponent, AlertEntityDialogComponent, AlertActionEntityDialogComponent, ActionNotificationComponent, ConfirmSelectEntityDialogComponent, ModalPasswordDialogComponent, ConfirmInputEntityDialogComponent, ModalCropDialogComponent } from './modals';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingScreenComponent } from './loading-screen/loading-screen.component';
import { ConfirmFileEntityDialogComponent } from './modals/confirm-file-entity-dialog/confirm-file-entity-dialog.component';
import { FlowComponent } from './modals/flow/flow.component';
import { OpeningActsComponent } from './modals/opening-acts/opening-acts.component';
import { CharactersComponent } from './modals/characters/characters.component';
import { CustomImageCropperDialogComponent } from './modals/image-cropper-dialog/image-cropper-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ClientsComponent } from './modals/clients/clients.component';
import { ModalUploaderDialogComponent } from './modals/custom-uploader-dialog/custom-uploader-dialog.component';
import { FlowAssignComponent } from './modals/flow-assign/flow-assign.component';
import { TagsComponent } from './modals/tags/tags.component';

@NgModule({
    imports: [
        RouterModule,
        CustomMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        TranslateModule,
        ImageCropperModule
    ],
    declarations: [
        ConfirmDialogComponent,
        ContentPlaceholderAnimationComponent,
        LimitToPipe,
        LocalDatePipe,
        YesNoPipe,
        LayoutComponent,
        UpdateStatusDialogComponent,
        FetchEntityDialogComponent,
        DeleteEntityDialogComponent,
        ErrorEntityDialogComponent,
        AlertEntityDialogComponent,
        AlertActionEntityDialogComponent,
        ActionNotificationComponent,
        ConfirmSelectEntityDialogComponent,
        ModalPasswordDialogComponent,
        ConfirmInputEntityDialogComponent,
        ModalCropDialogComponent,
        LoadingScreenComponent,
        ConfirmFileEntityDialogComponent,
        FlowComponent,
        OpeningActsComponent,
        CharactersComponent,
        CustomImageCropperDialogComponent,
        ClientsComponent,
        ModalUploaderDialogComponent,
        FlowAssignComponent,
        TagsComponent
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        CustomMaterialModule,
        LimitToPipe,
        ConfirmDialogComponent,
        ContentPlaceholderAnimationComponent,
        LocalDatePipe,
        YesNoPipe,
        UpdateStatusDialogComponent,
        FetchEntityDialogComponent,
        DeleteEntityDialogComponent,
        ErrorEntityDialogComponent,
        AlertEntityDialogComponent,
        AlertActionEntityDialogComponent,
        ActionNotificationComponent,
        ConfirmSelectEntityDialogComponent,
        ModalPasswordDialogComponent,
        ConfirmInputEntityDialogComponent,
        ModalCropDialogComponent,
        LoadingScreenComponent,
        ConfirmFileEntityDialogComponent,
        FlowComponent,
        OpeningActsComponent,
        CharactersComponent,
        CustomImageCropperDialogComponent,
        ClientsComponent,
        ModalUploaderDialogComponent,
        FlowAssignComponent,
        TagsComponent
    ],
    entryComponents: [
        UpdateStatusDialogComponent,
        FetchEntityDialogComponent,
        DeleteEntityDialogComponent,
        ErrorEntityDialogComponent,
        AlertEntityDialogComponent,
        AlertActionEntityDialogComponent,
        ActionNotificationComponent,
        ConfirmSelectEntityDialogComponent,
        ModalPasswordDialogComponent,
        ConfirmInputEntityDialogComponent,
        ModalCropDialogComponent,
        LoadingScreenComponent,
        ConfirmFileEntityDialogComponent,
        FlowComponent,
        OpeningActsComponent,
        CharactersComponent,
        CustomImageCropperDialogComponent,
        ClientsComponent,
        ModalUploaderDialogComponent,
        FlowAssignComponent,
        TagsComponent
    ]
})
export class SharedModule { }
